export const UsersActionTypes = {
  API_RESPONSE_SUCCESS: '@@usuarios/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@usuarios/API_RESPONSE_ERROR',

  GET_USER: '@@usuarios/GET_USER',
  LIST_USERS: '@@usuarios/LIST_USERS',
  ADD_USER: '@@usuarios/ADD_USER',
  UPDATE_USER: '@@usuarios/UPDATE_USER',
  UPDATE_USER_SELF: '@@usuarios/UPDATE_USER_SELF',
  DELETE_USER: '@@usuarios/DELETE_USER',

  RESET: '@@usuarios/RESET'
}
